<!-- filepath: c:\Project\git\hvmclient-ui\src\components\FileUpload.vue -->
<template>
	<div class="file-upload-container">
		<div class="file-upload">
			<label :for="inputId" class="file-upload-label">
				<span v-if="!selectedFile">파일 첨부</span>
				<span v-else>{{ selectedFileName }}</span>
			</label>
			<input :id="inputId" type="file" class="file-upload-input" @change="handleFileChange" ref="fileInput" />
			<button v-if="selectedFile" type="button" class="file-remove-btn" @click="removeFile">
				삭제
			</button>
		</div>
		<div v-if="uploading" class="file-upload-progress">
			<div class="progress-bar" :style="{ width: uploadProgress + '%' }"></div>
		</div>
		<p class="file-upload-info">
			* 첨부 가능 확장자: jpg, png, pdf, doc, docx, xls, xlsx (최대 5MB)
		</p>
	</div>
</template>

<script>
import { postAxios } from "@/lib/AxiosCall";

export default {
	name: "FileUpload",
	props: {
		maxSize: {
			type: Number,
			default: 5 * 1024 * 1024 // 5MB
		},
		allowedTypes: {
			type: Array,
			default: () => ['image/jpeg', 'image/png', 'application/pdf', 'application/msword',
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
				'application/vnd.ms-excel',
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
		}
	},
	data() {
		return {
			selectedFile: null,
			selectedFileName: "",
			uploading: false,
			uploadProgress: 0,
			inputId: `file-upload-${Date.now()}`
		};
	},
	methods: {
		async handleFileChange(event) {
			const file = event.target.files[0];
			if (!file) return;

			// 파일 유효성 검사
			if (file.size > this.maxSize) {
				alert(`파일 크기는 ${this.maxSize / (1024 * 1024)}MB를 초과할 수 없습니다.`);
				this.resetFileInput();
				return;
			}

			// 확장자 검사
			const fileExtension = file.name.split('.').pop().toLowerCase();
			const validExtensions = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx', 'xls', 'xlsx'];
			if (!validExtensions.includes(fileExtension)) {
				alert(`지원하지 않는 파일 형식입니다. 지원 형식: ${validExtensions.join(', ')}`);
				this.resetFileInput();
				return;
			}

			// 파일 선택 상태 업데이트
			this.selectedFile = file;
			this.selectedFileName = file.name;

			// 파일 업로드 시작
			this.uploadFile(file);
		},

		async uploadFile(file) {
			this.uploading = true;
			this.$emit('upload-progress', true);
			this.uploadProgress = 0;

			try {
				const formData = new FormData();
				formData.append('file', file);
				formData.append('fileYn', 'Y');

				// API를 통해 파일 업로드 - 헤더 객체 수정
				const response = await postAxios('/hvm/v1/common/file/upload', formData);

				// 업로드 완료 후 UUID 반환
				if (response) {
					console.log('파일 업로드 성공:', response);
					this.$emit('file-uploaded', {
						uuid: response.fileUuid,
						name: response.fileName
					});
				} else {
					throw new Error('파일 업로드 응답에 UUID가 없습니다.');
				}
			} catch (error) {
				console.error('파일 업로드 실패:', error);
				this.$emit('upload-error', error.message || '파일 업로드에 실패했습니다.');
				this.resetFileInput();
			} finally {
				this.uploading = false;
				this.$emit('upload-progress', false);
			}
		},

		removeFile() {
			this.resetFileInput();
			this.$emit('file-removed');
		},

		resetFileInput() {
			this.selectedFile = null;
			this.selectedFileName = "";
			this.uploadProgress = 0;
			// input 요소 초기화
			if (this.$refs.fileInput) {
				this.$refs.fileInput.value = '';
			}
		}
	}
};
</script>

<style scoped>
.file-upload-container {
	margin: 20px 0;
}

.file-upload {
	display: flex;
	align-items: center;
}

.file-upload-label {
	display: inline-block;
	padding: 8px 16px;
	background-color: #f5f5f5;
	border: 1px solid #ddd;
	border-radius: 4px;
	cursor: pointer;
	margin-right: 10px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 300px;
}

.file-upload-input {
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: -1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	border: 0;
}

.file-remove-btn {
	padding: 8px 16px;
	background-color: #ff6b6b;
	color: white;
	border: none;
	border-radius: 4px;
	cursor: pointer;
}

.file-upload-progress {
	margin-top: 10px;
	width: 100%;
	height: 4px;
	background-color: #f0f0f0;
	border-radius: 2px;
	overflow: hidden;
}

.progress-bar {
	height: 100%;
	background-color: #4caf50;
	transition: width 0.3s ease;
}

.file-upload-info {
	margin-top: 8px;
	font-size: 12px;
	color: #666;
}

.error-message {
	color: #ff6b6b;
	font-size: 12px;
	margin-top: 5px;
}
</style>